export default {
	// api请求地址
	baseUrl: 'https://junyuan.antennadt.com/',//'{{$baseUrl}}',
	// 图片域名
	imgDomain: 'https://junyuan.antennadt.com/',//'{{$imgDomain}}',
	// 腾讯地图key
	mpKey: '{{$mpKey}}',
	// 客服
	webSocket: 'wss://junyuan.antennadt.com/wss',//'{{$webSocket}}',
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 30000,
}